import { getRepository } from '@things-factory/shell'
import { Kpi } from '../kpi/kpi'
import { KpiValue } from './kpi-value'
import { scoreFromFormula, scoreFromLookup, ScoreResult } from '../../calculator/score.js'

export { ScoreResult }

export class KpiValueScoreService {
  /**
   * scoreFormula를 사용한 성과 점수 계산 — 순수 로직은 calculator/score 에 위임.
   * 파싱/평가 예외는 여기서 로그 후 null (점수 계산 실패는 치명 아님).
   */
  async calculateScoreFromFormula(kpi: Kpi, value: number): Promise<ScoreResult | null> {
    try {
      return await scoreFromFormula(kpi.scoreFormula, value)
    } catch (error) {
      console.error(`Score formula evaluation for '${kpi.name}: ${kpi.scoreFormula}' error:`, error)
      return null
    }
  }

  /**
   * KPI의 grades lookup table을 이용한 성과 점수 변환.
   * @deprecated 향후 grades 필드 제거 예정. scoreFormula로 대체 권장
   */
  calculateScoreFromLookup(kpi: Kpi, value: number): ScoreResult | null {
    return scoreFromLookup(kpi.grades as any, value)
  }

  /**
   * KpiValue 생성/수정 시 성과 점수 자동 계산 및 저장
   */
  async calculateAndSaveScore(kpiValue: KpiValue, kpi: Kpi): Promise<void> {
    // 1. scoreFormula 우선 시도
    let scoreResult = await this.calculateScoreFromFormula(kpi, kpiValue.value)

    // 2. scoreFormula가 없거나 실패하면 grades lookup table 사용 (deprecated)
    if (!scoreResult) {
      scoreResult = this.calculateScoreFromLookup(kpi, kpiValue.value)
    }

    if (scoreResult) {
      // KpiValue의 score 필드에 성과 점수 저장
      kpiValue.score = scoreResult.score
    }
  }

  /**
   * 기존 KpiValue들의 성과 점수 재계산 (배치 처리)
   */
  async recalculateScoresForKpi(kpiId: string, context: ResolverContext): Promise<void> {
    const kpi = await getRepository(Kpi).findOne({ where: { id: kpiId } })
    if (!kpi) return

    const kpiValues = await getRepository(KpiValue).find({
      where: { kpiId, version: kpi.version }
    })

    for (const kpiValue of kpiValues) {
      await this.calculateAndSaveScore(kpiValue, kpi)
    }

    await getRepository(KpiValue).save(kpiValues)
  }
}
